export enum ViewMode {
  READ_ONLY = "READ_ONLY",
  EDIT = "EDIT"
}
